<div class="adobe-status-container">
  <div class="adobe-status-panel">
    <h2 class="panel-title">Adobe Status Check</h2>
    <p class="panel-description">Calls POST https://firefly-api.adobe.io/v3/images/generate and shows the raw response.</p>

    <button type="button" class="submit-btn" (click)="checkStatus()" [disabled]="isLoading">
      {{ isLoading ? 'Checking...' : 'Check Status' }}
    </button>

    <div class="response-panel" *ngIf="responseStatus !== null">
      <div class="status-line">
        <span
          class="status-badge"
          [class.status-success]="responseStatus >= 200 && responseStatus < 300"
          [class.status-error]="responseStatus >= 400 || responseStatus === 0"
        >{{ responseStatus }}</span>
      </div>

      <textarea
        class="response-body"
        readonly
        [value]="responseBody"
      ></textarea>
    </div>
  </div>
</div>
